import Code from './Code'

export default class PickerValue{
	constructor({values = [], children = []} = {}, value = '') {
	    this.values = values
		this.defaultIndex = 0
		this.children = []
		
		this.init(value)
	}
	
	init(selectValue){
		if(selectValue == 'false'){
			selectValue = false
		}
		let i = 0
		for(i; i < this.values.length; i ++){
			const value = this.values[i]
			if(value instanceof Code || typeof value === 'object'){
				if(value.code == selectValue){
					this.defaultIndex = i
					return
				}
			}else{
				if(value == selectValue){
					this.defaultIndex = i
					return
				}
			}
		}
	}
}